/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Apps_Author_Floor_Locked_HintInputs */



/**
* | output |
* | --- |
* | "Dashboard authoring is floored to admins (dashboards only; canvas unaffected). This cell stays editable." |
*
* @param {Rights_Cap_Apps_Author_Floor_Locked_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_apps_author_floor_locked_hint = /** @type {((inputs?: Rights_Cap_Apps_Author_Floor_Locked_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Apps_Author_Floor_Locked_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboard-Erstellung ist auf Admins beschränkt (nur Dashboards; Canvas unberührt). Diese Zelle bleibt bearbeitbar.")
	return /** @type {LocalizedString} */ ("Dashboard authoring is floored to admins (dashboards only; canvas unaffected). This cell stays editable.")
});